import React, { useContext } from "react";

import { Grid, FormControlLabel, Switch } from "@material-ui/core";

import Card from "../../../../components/cards/Card";
import { Margin } from "../styles/Emissao";

import { EmissaoContext } from "../contexts/EmissaoContext";

export const AplicaveisBc = ({
  frete,
  setFrete,
  seguro,
  setSeguro,
  desconto,
  setDesconto,
  outras,
  setOutras,
  descIcms,
  setDescIcms,
}) => {
  const { visualizationOnly } = useContext(EmissaoContext);

  return (
    <Grid item sm={12}>
      <Card line="left" label="APLICÁVEIS BASE DE CÁLCULO">
        <Margin top="10">
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <FormControlLabel
              label="FRETE"
              value="end"
              control={
                <Switch
                  disabled={visualizationOnly}
                  checked={frete}
                  onChange={() => {
                    setFrete((current) => !current);
                  }}
                  color="primary"
                />
              }
            />
            <FormControlLabel
              label="SEGURO"
              value="end"
              control={
                <Switch
                  disabled={visualizationOnly}
                  checked={seguro}
                  onChange={() => {
                    setSeguro((current) => !current);
                  }}
                  color="primary"
                />
              }
            />
            <FormControlLabel
              label="DESCONTO"
              value="end"
              control={
                <Switch
                  disabled={visualizationOnly}
                  checked={desconto}
                  onChange={() => {
                    setDesconto((current) => !current);
                  }}
                  color="primary"
                />
              }
            />
            <FormControlLabel
              label="OUTRAS DESPESAS"
              value="end"
              control={
                <Switch
                  disabled={visualizationOnly}
                  checked={outras}
                  onChange={() => {
                    setOutras((current) => !current);
                  }}
                  color="primary"
                />
              }
            />
            {typeof descIcms !== "undefined" && (
              <FormControlLabel
                label="DESC. ICMS"
                value="end"
                control={
                  <Switch
                    disabled={visualizationOnly}
                    checked={descIcms}
                    onChange={() => {
                      setDescIcms((current) => !current);
                    }}
                    color="primary"
                  />
                }
              />
            )}
          </Grid>
        </Margin>
      </Card>
    </Grid>
  );
};

export const SearchRulesTaxation = (taxation) => {
  const jsonRules = {
    "00": {
      ICMS: [
        "modalidadeBcIcms",
        "bcIcms",
        "aliquotaIcms",
        "valorIcms",

        "aliquotaFundoCombPobreza",
        "bcFundoCombPobreza",
        "valorIcmsFundoCombPobreza",

        "aliquotaIcmsInterestadual",
        "aliquotaIcmsInternaDest",
        "cBenef",
      ],
      ST: null,
    },
    10: {
      ICMS: [
        "modalidadeBcIcms",
        "bcIcms",
        "aliquotaIcms",
        "valorIcms",
        "aliquotaFundoCombPobreza",
        "bcFundoCombPobreza",
        "valorIcmsFundoCombPobreza",

        "aliquotaIcmsInterestadual",
        "aliquotaIcmsInternaDest",
        "cBenef",
      ],
      ST: [
        "modalidadeBcIcmsSt",
        "mvaBcIcmsSt",
        "reducaoBcIcmsSt",
        "bcIcmsSt",
        "aliquotaIcmsSt",
        "valorIcmsSt",
        "bcFundoCombPobrezaSt",
        "aliquotaFundoCombPobrezaSt",
        "valorIcmsFundoCombPobrezaSt",
      ],
    },
    20: {
      ICMS: [
        "modalidadeBcIcms",
        "reducaoBcIcms",
        "bcIcms",
        "aliquotaIcms",
        "valorIcms",
        "icmsDesonerado",
        "motivoDesoneracao",
        "aliquotaFundoCombPobreza",
        "bcFundoCombPobreza",
        "valorIcmsFundoCombPobreza",
        "aliquotaIcmsInterestadual",
        "aliquotaIcmsInternaDest",
        "cBenef",
      ],
      ST: null,
    },
    30: {
      ICMS: [
        "icmsDesonerado",
        "motivoDesoneracao",
        "aliquotaIcmsInterestadual",
        "aliquotaIcmsInternaDest",
        "cBenef",
      ],
      ST: [
        "modalidadeBcIcmsSt",
        "mvaBcIcmsSt",
        "reducaoBcIcmsSt",
        "bcIcmsSt",
        "aliquotaIcmsSt",
        "valorIcmsSt",
        "bcFundoCombPobrezaSt",
        "aliquotaFundoCombPobrezaSt",
        "valorIcmsFundoCombPobrezaSt",
      ],
    },
    40: {
      ICMS: [
        "aliquotaIcmsInterestadual",
        "aliquotaIcmsInternaDest",
        "icmsDesonerado",
        "motivoDesoneracao",
        "cBenef",
      ],
      ST: null,
    },
    41: {
      ICMS: [
        "icmsDesonerado",
        "motivoDesoneracao",
        "aliquotaIcmsInterestadual",
        "aliquotaIcmsInternaDest",
        "cBenef",
      ],
      ST: ["bcRetidoIcmsSt", "valorRetidoIcmsSt"],
    },
    50: {
      ICMS: [
        "icmsDesonerado",
        "motivoDesoneracao",
        "aliquotaIcmsInterestadual",
        "aliquotaIcmsInternaDest",
        "cBenef",
      ],
      ST: null,
    },
    51: {
      ICMS: [
        "modalidadeBcIcms",
        "reducaoBcIcms",
        "bcIcms",
        "aliquotaIcms",
        "valorIcms",
        "aliquotaFundoCombPobreza",
        "bcFundoCombPobreza",
        "valorIcmsFundoCombPobreza",
        "aliquotaIcmsInterestadual",
        "aliquotaIcmsInternaDest",
        "cBenef",
      ],
      ST: null,
    },
    60: {
      ICMS: ["aliquotaIcmsInterestadual", "aliquotaIcmsInternaDest", "cBenef"],
      ST: [
        "bcIcmsSt",
        "valorIcmsSt",
        "bcRetidoIcmsSt",
        "valorRetidoIcmsSt",
        "bcFcpRetidoIcmsSt",
        "bcFundoCombPobrezaSt",
        "aliquotaFundoCombPobrezaSt",
        "valorIcmsFundoCombPobrezaSt",
      ],
    },
    70: {
      ICMS: [
        "modalidadeBcIcms",
        "reducaoBcIcms",
        "bcIcms",
        "aliquotaIcms",
        "valorIcms",
        "icmsDesonerado",
        "motivoDesoneracao",
        "aliquotaFundoCombPobreza",
        "bcFundoCombPobreza",
        "valorIcmsFundoCombPobreza",
        "aliquotaIcmsInterestadual",
        "aliquotaIcmsInternaDest",
        "cBenef",
      ],
      ST: [
        "modalidadeBcIcmsSt",
        "mvaBcIcmsSt",
        "reducaoBcIcmsSt",
        "bcIcmsSt",
        "aliquotaIcmsSt",
        "valorIcmsSt",
        "bcFundoCombPobrezaSt",
        "aliquotaFundoCombPobrezaSt",
        "valorIcmsFundoCombPobrezaSt",
      ],
    },
    90: {
      ICMS: [
        "modalidadeBcIcms",
        "reducaoBcIcms",
        "bcIcms",
        "aliquotaIcms",
        "valorIcms",
        "icmsDesonerado",
        "motivoDesoneracao",
        "aliquotaFundoCombPobreza",
        "bcFundoCombPobreza",
        "valorIcmsFundoCombPobreza",
        "aliquotaIcmsInterestadual",
        "aliquotaIcmsInternaDest",
        "cBenef",
      ],
      ST: [
        "modalidadeBcIcmsSt",
        "mvaBcIcmsSt",
        "reducaoBcIcmsSt",
        "bcIcmsSt",
        "aliquotaIcmsSt",
        "valorIcmsSt",
        "bcFundoCombPobrezaSt",
        "aliquotaFundoCombPobrezaSt",
        "valorIcmsFundoCombPobrezaSt",
      ],
    },
    101: {
      ICMS: ["aliquotaCredIcms", "credAproveitadoIcms", "cBenef"],
      ST: null,
    },
    102: {
      ICMS: ["cBenef"],
      ST: null,
    },
    103: {
      ICMS: ["cBenef"],
      ST: null,
    },
    201: {
      ICMS: [
        "aliquotaCredIcms",
        "credAproveitadoIcms",
        "reducaoBcIcms",
        "aliquotaIcmsInterestadual",
        "bcIcms",
        "aliquotaIcms",
        "valorIcms",
        "cBenef",
      ],
      ST: [
        "modalidadeBcIcmsSt",
        "mvaBcIcmsSt",
        "reducaoBcIcmsSt",
        "bcIcmsSt",
        "aliquotaIcmsSt",
        "valorIcmsSt",
        "bcFundoCombPobrezaSt",
        "aliquotaFundoCombPobrezaSt",
        "valorIcmsFundoCombPobrezaSt",
      ],
    },
    202: {
      ICMS: [
        "reducaoBcIcms",
        "bcIcms",
        "aliquotaIcms",
        "aliquotaIcmsInterestadual",
        "valorIcms",
        "cBenef",
      ],
      ST: [
        "modalidadeBcIcmsSt",
        "mvaBcIcmsSt",
        "reducaoBcIcmsSt",
        "bcIcmsSt",
        "aliquotaIcmsSt",
        "valorIcmsSt",
        "bcFundoCombPobrezaSt",
        "aliquotaFundoCombPobrezaSt",
        "valorIcmsFundoCombPobrezaSt",
      ],
    },
    203: {
      ICMS: [
        "reducaoBcIcms",
        "bcIcms",
        "aliquotaIcms",
        "aliquotaIcmsInterestadual",
        "valorIcms",
        "cBenef",
      ],
      ST: [
        "modalidadeBcIcmsSt",
        "mvaBcIcmsSt",
        "reducaoBcIcmsSt",
        "bcIcmsSt",
        "aliquotaIcmsSt",
        "valorIcmsSt",
        "bcFundoCombPobrezaSt",
        "aliquotaFundoCombPobrezaSt",
        "valorIcmsFundoCombPobrezaSt",
      ],
    },
    300: {
      ICMS: ["aliquotaIcmsInterestadual", "cBenef"],
      ST: null,
    },
    400: {
      ICMS: ["aliquotaIcmsInterestadual", "cBenef"],
      ST: null,
    },
    500: {
      ICMS: ["aliquotaIcmsInterestadual", "cBenef"],
      ST: [
        "aliquotaConsumidorIcms",
        "valorProprioIcms",
        "bcRetidoIcmsSt",
        "valorRetidoIcmsSt",
        "bcFcpRetidoIcmsSt",
        "aliquotaFcpRetidoIcmsSt",
        "valorFcpRetidoIcmsSt",
      ],
    },
    900: {
      ICMS: [
        "modalidadeBcIcms",
        "reducaoBcIcms",
        "aliquotaIcmsInterestadual",
        "bcIcms",
        "aliquotaIcms",
        "valorIcms",
        "aliquotaCredIcms",
        "credAproveitadoIcms",
        "cBenef",
      ],
      ST: [
        "modalidadeBcIcmsSt",
        "mvaBcIcmsSt",
        "reducaoBcIcmsSt",
        "bcIcmsSt",
        "aliquotaIcmsSt",
        "valorIcmsSt",
        "bcFundoCombPobrezaSt",
        "aliquotaFundoCombPobrezaSt",
        "valorIcmsFundoCombPobrezaSt",
      ],
    },
  };
  return jsonRules[taxation];
};
